import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//

import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { useConfigProfile } from "../profile/ConfigurationProfile";
var lightColor = "rgba(255, 255, 255, 0.7)";
var styles = function styles(theme) {
  return {
    button: {
      borderColor: lightColor
    }
  };
};
var ConfigurationProfileButton = function ConfigurationProfileButton(_ref) {
  var classes = _ref.classes;
  var _useConfigProfile = useConfigProfile(),
    _useConfigProfile2 = _slicedToArray(_useConfigProfile, 2),
    profile = _useConfigProfile2[0],
    setProfile = _useConfigProfile2[1];
  return /*#__PURE__*/React.createElement(Button, {
    className: classes.button,
    variant: "outlined",
    color: "inherit",
    size: "small"
  }, "Definition:", " ", profile && profile.name ? profile.name : "Untitled");
};
export default withStyles(styles)(ConfigurationProfileButton);